import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { dateFun } from "../../../utils";

export const stageGateConfig = (user, leadId, tableData = []) => {
  const resgistrationObj = tableData?.find(
    (stage) => stage?.stageName === "Registration"
  );
  const config = [
    {
      label: "Stage",
      id: "stageName",
      key: "stageName",
      value: (data) => {
        return data?.stage?.stageName;
      },
    },
    { label: "Status", id: "status", key: "status" },
    {
      label: "Actual Date",
      id: "actualDate",
      render: (data, _, index) => {
        return <div id={index}>{dateFun(data?.actualDate)}</div>;
      },
      value: (data) => {
        return dateFun(data?.actualDate);
      },
    },
    {
      label: "Actions",
      id: "Actions",
      render: (data, onclick) => {
        return (
          <div id={Math.random()}>
            <IconButton
              onClick={() => {
                onclick(data, "edit");
              }}
              sx={{ p: 0 }}
              disabled={
                (leadId &&
                  parseInt(user?.id) !== 18 &&
                  data.status === "Completed") ||
                (data?.stageNumber > resgistrationObj?.stageNumber &&
                  resgistrationObj?.registration === "No")
              }
            >
              <EditIcon id="edit" />
            </IconButton>
          </div>
        );
      },
    },
  ];

  return config;
};
